





































































































































































import {defineComponent} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';
import CalculationInput from '@/tasks/components/inputs/CalculationInput.vue';

export default defineComponent({
  name: 'ChemMcM1AA3Lab6V2Results',
  components: {
    CalculationInput,
    ChemicalLatex,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        titrant: null,
        analyte: null,
        initialPH: null,
        pHEqPt: null,
        Veq: null,
        molTitrantEq: null,
        molAnalyte: null,
        volAnalyte: null,
        concAnalyte: null,
        pHHalfEqPt: null,
        pKa: null,
        Ka: null,
      },
      options1: [
        {text: '$\\ce{CH3COOH}$', value: 'CH3COOH'},
        {text: '$\\ce{HCl}$', value: 'HCl'},
        {text: '$\\ce{NaOH}$', value: 'NaOH'},
        {text: '$\\ce{NH3}$', value: 'NH3'},
      ],
    };
  },
});
